"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_core_1 = require("@datadog/browser-core");
var lifeCycle_1 = require("./lifeCycle");
function trackEventCounts(lifeCycle, callback) {
    if (callback === void 0) { callback = browser_core_1.noop; }
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0,
    };
    var subscriptions = [];
    subscriptions.push(lifeCycle.subscribe(lifeCycle_1.LifeCycleEventType.ERROR_COLLECTED, function () {
        eventCounts.errorCount += 1;
        callback(eventCounts);
    }));
    subscriptions.push(lifeCycle.subscribe(lifeCycle_1.LifeCycleEventType.AUTO_ACTION_COMPLETED, function () {
        eventCounts.userActionCount += 1;
        callback(eventCounts);
    }));
    subscriptions.push(lifeCycle.subscribe(lifeCycle_1.LifeCycleEventType.CUSTOM_ACTION_COLLECTED, function () {
        eventCounts.userActionCount += 1;
        callback(eventCounts);
    }));
    subscriptions.push(lifeCycle.subscribe(lifeCycle_1.LifeCycleEventType.PERFORMANCE_ENTRY_COLLECTED, function (entry) {
        if (entry.entryType === 'longtask') {
            eventCounts.longTaskCount += 1;
            callback(eventCounts);
        }
    }));
    subscriptions.push(lifeCycle.subscribe(lifeCycle_1.LifeCycleEventType.RESOURCE_ADDED_TO_BATCH, function () {
        eventCounts.resourceCount += 1;
        callback(eventCounts);
    }));
    return {
        stop: function () {
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        },
        eventCounts: eventCounts,
    };
}
exports.trackEventCounts = trackEventCounts;
//# sourceMappingURL=trackEventCounts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/cjs/trackEventCounts.js
// module id = 380
// module chunks = 0